import { getIDTaggingFromIDML, TranslationData, useIDTagging, useMeasurementUnitsList } from '@msdk/common'
import { EMPTY_CELL_VALUE, Entity, FieldValue } from '@msdk/definitions'
import React from 'react'

interface Props {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  value: FieldValue<any> | null
  row?: Entity
}

export function MeasurementUnit(props: Props) {
  const mus = useMeasurementUnitsList()

  let translatedMU = EMPTY_CELL_VALUE

  const mu = mus?.find((x) => x.key === props.value?.value)
  const idTaggingEnabled = useIDTagging()

  if (mu) {
    const translatedDescription = mu.tDescription ? mu.tDescription : mu.description

    const data: Record<string, TranslationData> = {}
    data[mu.idml] = {
      msName: mu.msName,
      sectionName: mu.sectionName,
      tDescription: translatedDescription,
      isSystem: mu.isSystem,
    }
    translatedMU = idTaggingEnabled ? getIDTaggingFromIDML(mu.idml, data) : translatedDescription
  } else {
    translatedMU = props.value?.value as string
  }

  return (
    <>
      <span>{translatedMU}</span>
    </>
  )
}
